import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { info } from "console";
import { ToastrService } from "ngx-toastr";
import { PortService } from "src/app/core-services/port.service";
import { OpenSearchFinderFields, OpenSearchScreen } from "src/app/Enum/Enum";
import { Country } from "src/app/models/Country";
import { Result } from "src/app/models/ResultModel";
import { OpenSearchService } from "../../landing/services/open-searches.service";
import { FreeSearchConfigVM, OpenSearchModel } from "./model/open-search.model";
import { AdminService } from "../../landing/services/admin.service";

@Component({
    selector: 'app-open-search',
    templateUrl: './open-searches.component.html',
    styleUrls: ['./open-searches.component.scss']
})
export class OpenSearchComponent implements OnInit {
    shippingLines: any[];
    masterDestinationCountries: Country[] = [];
    trackerDestinationCountries: Country[] = [];
    actvitiesDestinationCountries: Country[] = [];
    masterSourceCountries: Country[] = [];
    masterDestinationPorts: any[] = [];
    masterSourcePorts: any[] = [];
    trackerDestinationPorts: any[] = [];
    trackerSourcePorts: any[] = [];
    activitiesDestinationPorts: any[] = [];
    activitiesSourcePorts: any[] = [];
    openSearch: OpenSearchModel[] = [];
    voyageFinderOpenSearch: OpenSearchModel[];
    shipmentTrackerOpenSearch: OpenSearchModel[];
    portActivitiesOpenSearch: OpenSearchModel[];
    rateRequestOpenSearch: OpenSearchModel[];
    hasFinderSettingSet = false;
    featureNames = Array();
    ipLogs = [];
    searchForm = this.fb.group({
        toCountry: ["" as any, Validators.required],
        fromCountry: ["" as any, Validators.required],
        fromPort: ['' as any, Validators.required],
        toPort: ['' as any, Validators.required],
        active: [false],
        enableDefaultValues: [false],
        count: ['']
    });
    trackerForm = this.fb.group({
        toCountry: ["" as any, Validators.required],
        fromCountry: ["" as any, Validators.required],
        fromPort: ['' as any, Validators.required],
        toPort: ['' as any, Validators.required],
        active: [false],
        enableDefaultValues: [false],
        count: ['']
    });
    portActivitiesForm = this.fb.group({
        port: ["" as any],
        shippingline: ["" as any],
        vessel: ['' as any],
        active: [false],
        enableDefaultValues: [false],
        count: [''],
        fromCountry: ["" as any],
        toCountry: ["" as any],
        toPort: ['' as any],
        fromPort: ['' as any]
    });
    rateRequestForm = this.fb.group({
        active: [false],
        count: ['']
    });
    userStatus = "NONLOGGEDIN";
    groupedLogs: { date: string, entries: any[] }[] = [];
    portList: any = [];
    vesselList: any = [];
    shippinglineList: any = [];
    constructor(private fb: FormBuilder, private portService: PortService, private openSearchService: OpenSearchService,
        private toastr: ToastrService) {

    }

    ngOnInit(): void {
        this.setFeatureName();
        this.getOpenSearches();
        this.getShippingLine();
        this.getVessels();
        this.getPorts();

    }

    getShippingLine() {
        this.portService.GetShippingLines().subscribe((data: any) => {
            this.shippinglineList = data.content.map((item: any) => ({
                id: item.shippingLineId,
                name: item.shippingLineName
            }));
        });
    }

    getVessels() {
        this.portService.GetvoyageandvesselsList().subscribe((data: any) => {
            this.vesselList = data.content.vessels.map((item: any) => ({
                id: item.id,
                name: item.vesselsName
            }));
        });
    }

    getPorts() {
        this.portService.GetPortData().subscribe((data: any) => {
            this.portList = data.content.map((item: any) => ({
                id: item.id,
                name: item.portName
            }));
        });
    }

    getFreeSearchPolicies() {
        this.openSearchService.getFreeSearchPolicy().subscribe(z => {
            console.log(z);
        })
    }

    setFeatureName() {
        this.featureNames = ["Route Finder", "Shipment Tracker", "Port Activities"];
    }
    groupByDate(logs: any[]): any[] {
        const grouped: { [key: string]: any[] } = {};
        logs.forEach(log => {
            if (!grouped[log.searchDate]) {
                grouped[log.searchDate] = [];
            }
            grouped[log.searchDate].push(log);
        });

        return Object.keys(grouped).map(searchDate => ({
            searchDate,
            entries: grouped[searchDate]
        }));
    }

    getIpLogs(ipAcessLogs: any[]) {
        this.ipLogs = ipAcessLogs.sort((a, b) => new Date(b.searchDate).getTime() - new Date(a.searchDate).getTime());

        this.groupedLogs = this.ipLogs;
    }

    onFinderSubmit() {
        if (this.searchForm.invalid) {
            this.showValidationError(this.searchForm);
        } else {
            this.buildOpenSearchRequestPayload();
            this.openSearchService.updateOpenSearch(this.voyageFinderOpenSearch).subscribe(res => {
                this.toastr.success("Port-to-Port settng saved successfully.", "Success!");
            });
        }
    }
    onShipmentTrackerSubmit() {
        if (this.trackerForm.invalid) {
            this.showValidationError(this.trackerForm);
        } else {
            this.buildShipmentTrackerOpenSearchRequestPayload();
            this.openSearchService.updateOpenSearch(this.shipmentTrackerOpenSearch).subscribe(res => {
                this.toastr.success("Data has been saved successfully.", "Success!");
            });
        }
    }
    onPortActivitiesSubmit() {
        if (this.portActivitiesForm.invalid) {
            this.showValidationError(this.portActivitiesForm);
        } else {
            this.buildPortActivityOpenSearchRequestPayload();
            this.openSearchService.updateOpenSearch(this.portActivitiesOpenSearch).subscribe(res => {
                this.toastr.success("Data has been saved successfully.", "Success!");
            });
        }
    }




    onRateRequestSubmit() {
        if (this.rateRequestForm.invalid) {
            this.showValidationError(this.rateRequestForm);
        } else {
            this.buildRateRquestPayload();
            this.openSearchService.updateOpenSearch(this.rateRequestOpenSearch).subscribe(res => {
                this.toastr.success("Data has been saved successfully.", "Success!");
            });
        }
    }

    onUserStatusChange() {
        this.setOpenSearchData(this.openSearch);
    }

    private buildOpenSearchRequestPayload() {
        if (!this.searchForm.value.active) {
            this.voyageFinderOpenSearch.forEach((element: any)=> {
                element.active = this.searchForm.value.active;
                element.count = this.searchForm.value.count;
            });
        }
        else if (this.searchForm.value.active && !this.searchForm.value.enableDefaultValues) {
            this.voyageFinderOpenSearch.forEach((element: any) => {
                element.active = this.searchForm.value.active;
                element.count = this.searchForm.value.count;
                element.enableDefaultValues = this.searchForm.value.enableDefaultValues;
            });
        }
        else if (
            this.searchForm.value.active &&
            this.searchForm.value.enableDefaultValues &&
            this.voyageFinderOpenSearch && this.voyageFinderOpenSearch.length) {
            this.voyageFinderOpenSearch.forEach((element: any) => {
                if (element.fieldName == OpenSearchFinderFields.FromCountry) {
                    element.fieldValue = (this.searchForm.value.fromCountry as any)?.id
                }
                else if (element.fieldName == OpenSearchFinderFields.FromPort) {
                    element.fieldValue = (this.searchForm.value.fromPort as any)?.id
                }
                else if (element.fieldName == OpenSearchFinderFields.ToCountry) {
                    element.fieldValue = (this.searchForm.value.toCountry as any)?.id
                }
                else if (element.fieldName == OpenSearchFinderFields.ToPort) {
                    element.fieldValue = (this.searchForm.value.toPort as any)?.id
                }
                element.active = this.searchForm.value.active;
                element.userType = this.userStatus;
                element.enableDefaultValues = this.searchForm.value.enableDefaultValues;
                element.count = this.searchForm.value.count;
            });
        }
    }
    private buildShipmentTrackerOpenSearchRequestPayload() {
        if (!this.trackerForm.value.active) {
            this.shipmentTrackerOpenSearch.forEach((element: any) => {
                element.active = this.trackerForm.value.active;
                element.count = this.trackerForm.value.count;
            });
        }
        else if (
            this.trackerForm.value.active &&
            this.trackerForm.value.enableDefaultValues &&
            this.shipmentTrackerOpenSearch && this.shipmentTrackerOpenSearch.length) {
            this.shipmentTrackerOpenSearch.forEach((element: any) => {
                if (element.fieldName == OpenSearchFinderFields.FromCountry) {
                    element.fieldValue = this.trackerForm.value.fromCountry.id
                }
                else if (element.fieldName == OpenSearchFinderFields.FromPort) {
                    element.fieldValue = this.trackerForm.value.fromPort.id
                }
                else if (element.fieldName == OpenSearchFinderFields.ToCountry) {
                    element.fieldValue = this.trackerForm.value.toCountry.id
                }
                else if (element.fieldName == OpenSearchFinderFields.ToPort) {
                    element.fieldValue = this.trackerForm.value.toPort.id
                }
                element.active = this.trackerForm.value.active;
                element.userType = this.userStatus;
                element.enableDefaultValues = this.trackerForm.value.enableDefaultValues;
                element.count = this.trackerForm.value.count;
            });
        }
    }
    private buildPortActivityOpenSearchRequestPayload() {
        if (!this.portActivitiesForm.value.active) {
            this.portActivitiesOpenSearch.forEach((element: any) => {
                element.active = this.portActivitiesForm.value.active;
                element.count = this.portActivitiesForm.value.count;
            });
        }
        else if (this.portActivitiesForm.value.active && !this.portActivitiesForm.value.enableDefaultValues) {
            this.portActivitiesOpenSearch.forEach((element: any) => {
                element.active = this.portActivitiesForm.value.active;
                element.count = this.portActivitiesForm.value.count;
                element.enableDefaultValues = this.portActivitiesForm.value.enableDefaultValues;
            });
        }
        else if (this.portActivitiesForm.value.active &&
            this.portActivitiesForm.value.enableDefaultValues &&
            this.portActivitiesOpenSearch &&
            this.portActivitiesOpenSearch.length) {
            this.portActivitiesOpenSearch.forEach((element: any) => {
                if (element.fieldName == OpenSearchFinderFields.Shippingline) {
                    element.fieldValue = this.portActivitiesForm.value.shippingline.id
                }
                else if (element.fieldName == OpenSearchFinderFields.Vessel) {
                    element.fieldValue = this.portActivitiesForm.value.vessel.id
                }
                else if (element.fieldName == OpenSearchFinderFields.Port) {
                    element.fieldValue = this.portActivitiesForm.value.port.id
                }
                element.active = this.portActivitiesForm.value.active;
                element.userType = this.userStatus;
                element.enableDefaultValues = this.portActivitiesForm.value.enableDefaultValues;
                element.count = this.portActivitiesForm.value.count;
            });
        }
    }

    private buildRateRquestPayload() {
        // if (!this.rateRequestForm.value.active) {
            this.rateRequestOpenSearch.forEach((element: any) => {
                element.active = this.rateRequestForm.value.active;
                element.count = this.rateRequestForm.value.count;
            });
        // }
    }

    onEnableCLick(event, formName: string) {
        if (formName == OpenSearchScreen.Finder) {
            Object.keys(this.searchForm.controls).forEach(controlName => {
                if (controlName !== 'active') {
                    if (event.currentTarget.checked) {
                        this.searchForm.get(controlName).enable();
                    } else {
                        this.searchForm.get(controlName).disable();
                    }
                }
            });
        } else if (formName == OpenSearchScreen.PortActivities) {
            Object.keys(this.portActivitiesForm.controls).forEach(controlName => {
                if (controlName !== 'active') {
                    if (event.currentTarget.checked) {
                        this.portActivitiesForm.get(controlName).enable();
                    } else {
                        this.portActivitiesForm.get(controlName).disable();
                    }
                }
            });

        } else if (formName == OpenSearchScreen.Tracker) {
            Object.keys(this.trackerForm.controls).forEach(controlName => {
                if (controlName !== 'active') {
                    if (event.currentTarget.checked) {
                        this.trackerForm.get(controlName).enable();
                    } else {
                        this.trackerForm.get(controlName).disable();
                    }
                }
            });
        }
        else if (formName == OpenSearchScreen.RateRequest) {
            Object.keys(this.rateRequestForm.controls).forEach(controlName => {
                if (controlName !== 'active') {
                    if (event.currentTarget.checked) {
                        this.rateRequestForm.get(controlName).enable();
                    } else {
                        this.rateRequestForm.get(controlName).disable();
                    }
                }
            });
        }
    }

    onDefaultSearchCLick(event, formName: string) {
        if (formName == OpenSearchScreen.Finder) {
            Object.keys(this.searchForm.controls).forEach(controlName => {
                if (controlName !== 'enableDefaultValues' && controlName !== 'active' && controlName !== 'count') {
                    if (event.currentTarget.checked) {
                        this.searchForm.get(controlName).enable();
                    } else {
                        this.searchForm.get(controlName).disable();
                    }
                }
            });
        } else if (formName == OpenSearchScreen.PortActivities) {
            Object.keys(this.portActivitiesForm.controls).forEach(controlName => {
                if (controlName !== 'active' && controlName !== 'enableDefaultValues' && controlName !== 'count') {
                    if (event.currentTarget.checked) {
                        this.portActivitiesForm.get(controlName).enable();
                    } else {
                        this.portActivitiesForm.get(controlName).disable();
                    }
                }
            });

        } else if (formName == OpenSearchScreen.Tracker) {
            Object.keys(this.trackerForm.controls).forEach(controlName => {
                if (controlName !== 'active' && controlName !== 'enableDefaultValues' && controlName !== 'count') {
                    this.trackerForm
                    if (event.currentTarget.checked) {
                        this.trackerForm.get(controlName).enable();
                    } else {
                        this.trackerForm.get(controlName).disable();
                    }
                }
            });

        }
    }

    private showValidationError(searchForm: FormGroup) {
        if (!searchForm.value.fromCountry) {
            this.toastr.error("Please select from country.", "Error!");
            return false;
        }

        if (!searchForm.value.fromPort) {
            this.toastr.error("Please select from port.", "Error!");
            return false;
        }

        if (!searchForm.value.toCountry) {
            this.toastr.error("Please select to country.", "Error!");
            return false;
        }

        if (!searchForm.value.toPort) {
            this.toastr.error("Please select to port.", "Error!");
            return false;
        }

        return true;
    }

    getOpenSearches() {
        this.openSearchService.getOpenSearch().subscribe((res: Result<FreeSearchConfigVM>) => {
            if (res && res.succeeded && res.data) {
                this.getIpLogs(res.data.ipAcessLogs);
                this.setOpenSearchData(res.data.openSearchConfig, true);
            }
        }, (error => {
            console.log("getOpenSearch error.")
            console.log(error);
        }));
    }

    disableOnEnableCheckBox(formGroup: FormGroup, value) {
        Object.keys(formGroup.controls).forEach(controlName => {
            if (controlName == 'enableDefaultValues' || controlName == 'count') {
                if (value) {
                    formGroup.get(controlName).enable();
                } else {
                    formGroup.get(controlName).disable();
                }
            }
        });
    }

    disableOnDefaultValueCheckBox(formGroup: FormGroup, value) {
        Object.keys(formGroup.controls).forEach(controlName => {
            if (controlName !== 'active' && controlName !== 'count' && controlName != 'enableDefaultValues') {
                if (value) {
                    formGroup.get(controlName).enable();
                } else {
                    formGroup.get(controlName).disable();
                }
            }
        });
    }

    setOpenSearchData(openSearchConfig: any, onPageLoad = false) {
        this.openSearch = openSearchConfig;
        this.voyageFinderOpenSearch = this.openSearch.filter(z => z.featureName === OpenSearchScreen.Finder && z.userType == this.userStatus);
        this.portActivitiesOpenSearch = this.openSearch.filter(z => z.featureName === OpenSearchScreen.PortActivities && z.userType == this.userStatus);
        this.rateRequestOpenSearch = this.openSearch.filter(z => z.featureName === OpenSearchScreen.RateRequest && z.userType == this.userStatus);
        this.shipmentTrackerOpenSearch = this.openSearch.filter(z => z.featureName === OpenSearchScreen.Tracker && z.userType == this.userStatus);
        this.getSourceCountries();

        this.rateRequestForm.controls.active.setValue(this.rateRequestOpenSearch[0].active as any);
        this.rateRequestForm.controls.count.setValue(this.rateRequestOpenSearch[0].count as any);
        this.disableOnEnableCheckBox(this.rateRequestForm, this.rateRequestOpenSearch[0].active);

        let finderFromCountry = this.voyageFinderOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.FromCountry);
        if (finderFromCountry && finderFromCountry.fieldValue) {
            this.hasFinderSettingSet = true;
            this.getSourcePorts(finderFromCountry.fieldValue, true, OpenSearchScreen.Finder)
            const finderFromPort = this.voyageFinderOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.FromPort);
            this.getDestinationCountries(finderFromCountry.fieldValue, [finderFromPort.fieldValue], true, OpenSearchScreen.Finder);
            const finderToCountry = this.voyageFinderOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.ToCountry);
            this.getDestinationPorts(finderToCountry.fieldValue, [finderFromPort.fieldValue], true, OpenSearchScreen.Finder);
            this.searchForm.controls.active.setValue(finderFromCountry.active as any);
            this.searchForm.controls.enableDefaultValues.setValue(finderFromCountry.enableDefaultValues);
            this.searchForm.controls.count.setValue(finderFromCountry.count as any);
            if (onPageLoad) {
                this.disableOnEnableCheckBox(this.searchForm, finderFromCountry.active);
                this.disableOnDefaultValueCheckBox(this.searchForm, finderFromCountry.enableDefaultValues);
            }
        } else {
            this.hasFinderSettingSet = false;
        }

        let portActivityPort = this.portActivitiesOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.Port);
        let portActivityVessel = this.portActivitiesOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.Vessel);
        let portActivityShippingline = this.portActivitiesOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.Shippingline);
        if (portActivityPort) {
            this.hasFinderSettingSet = true;
            this.portActivitiesForm.controls.active.setValue(portActivityPort.active as any);
            this.portActivitiesForm.controls.enableDefaultValues.setValue(portActivityPort.enableDefaultValues);
            this.portActivitiesForm.controls.count.setValue(portActivityPort.count as any);
            this.portActivitiesForm.controls.vessel.setValue(portActivityVessel.fieldValue);
            this.portActivitiesForm.controls.port.setValue(portActivityPort.fieldValue);
            this.portActivitiesForm.controls.shippingline.setValue(portActivityShippingline.fieldName);
            if (onPageLoad) {
                this.disableOnEnableCheckBox(this.portActivitiesForm, portActivityPort.active);
                this.disableOnDefaultValueCheckBox(this.portActivitiesForm, portActivityPort.enableDefaultValues);
            }
        }

        let trackerFromCountry = this.shipmentTrackerOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.FromCountry);
        if (trackerFromCountry && trackerFromCountry.fieldValue) {
            this.hasFinderSettingSet = true;
            this.getSourcePorts(trackerFromCountry.fieldValue, true, OpenSearchScreen.Tracker)
            const finderFromPort = this.shipmentTrackerOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.FromPort);
            this.getDestinationCountries(trackerFromCountry.fieldValue, [finderFromPort.fieldValue], true, OpenSearchScreen.Tracker);
            const finderToCountry = this.shipmentTrackerOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.ToCountry);
            this.getDestinationPorts(finderToCountry.fieldValue, [finderFromPort.fieldValue], true, OpenSearchScreen.Tracker);
            this.trackerForm.controls.active.setValue(trackerFromCountry.active as any);
            this.trackerForm.controls.enableDefaultValues.setValue(trackerFromCountry.enableDefaultValues);
            this.trackerForm.controls.count.setValue(trackerFromCountry.count as any);
            if (onPageLoad) {
                this.disableOnEnableCheckBox(this.trackerForm, trackerFromCountry.active);
                this.disableOnDefaultValueCheckBox(this.trackerForm, trackerFromCountry.enableDefaultValues);
            }
        }
    }

    getDestinationCountries(fromCountryId, fromPortIds, isSetDefault: boolean, type: string) {
        this.portService.getDestinationCountryList(fromCountryId, fromPortIds).subscribe((response: any) => {
            if (response != null && response.succeeded && response.data != null) {
                if (type == OpenSearchScreen.Finder) {
                    this.masterDestinationCountries = response.data;
                } else if (type == OpenSearchScreen.PortActivities) {
                    this.actvitiesDestinationCountries = response.data;
                } else if (type == OpenSearchScreen.Tracker) {
                    this.trackerDestinationCountries = response.data;
                }
                if (this.hasFinderSettingSet) {
                    if (type == OpenSearchScreen.Finder) {
                        const finderToCountry = this.voyageFinderOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.ToCountry);
                        for (let element of this.masterDestinationCountries) {
                            if (element.id == finderToCountry.fieldValue) {
                                this.searchForm.controls.toCountry.setValue(element);
                            }
                        }
                    }
                    //  else if (type == OpenSearchScreen.PortActivities) {
                    //     const finderToCountry = this.portActivitiesOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.ToCountry);
                    //     for (let element of this.actvitiesDestinationCountries) {
                    //         if (element.id == finderToCountry.fieldValue) {
                    //             this.portActivitiesForm.controls.toCountry.setValue(element);
                    //         }
                    //     }
                    // }
                    else if (type == OpenSearchScreen.Tracker) {
                        const finderToCountry = this.shipmentTrackerOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.ToCountry);
                        for (let element of this.trackerDestinationCountries) {
                            if (element.id == finderToCountry.fieldValue) {
                                this.trackerForm.controls.toCountry.setValue(element as any);
                            }
                        }
                    }
                }
            }
        });
    }

    getDestinationPorts(toCountryId, fromPortIds, isSetDefault: boolean, type: string) {
        this.portService.getDestinationPortList(toCountryId, fromPortIds).subscribe((response: any) => {
            if (response != null && response.succeeded && response.data != null) {
                if (type == OpenSearchScreen.Finder) {
                    this.masterDestinationPorts = response.data;
                } else if (type == OpenSearchScreen.PortActivities) {
                    this.activitiesDestinationPorts = response.data;
                } else if (type == OpenSearchScreen.Tracker) {
                    this.trackerDestinationPorts = response.data;
                }
                if (this.hasFinderSettingSet) {
                    if (type == OpenSearchScreen.Finder) {
                        const finderToCountry = this.voyageFinderOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.ToPort);
                        let selectedToPorts = this.masterDestinationPorts.find(x => x.id == finderToCountry.fieldValue);
                        this.searchForm.controls.toPort.setValue(selectedToPorts);
                    }
                    //  else if (type == OpenSearchScreen.PortActivities) {
                    //     const finderToCountry = this.portActivitiesOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.ToPort);
                    //     let selectedToPorts = this.activitiesDestinationPorts.find(x => x.id == finderToCountry.fieldValue);
                    //     this.portActivitiesForm.controls.toPort.setValue(selectedToPorts);
                    // } 
                    else if (type == OpenSearchScreen.Tracker) {
                        const finderToCountry = this.shipmentTrackerOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.ToPort);
                        let selectedToPorts = this.trackerDestinationPorts.find(x => x.id == finderToCountry.fieldValue);
                        this.trackerForm.controls.toPort.setValue(selectedToPorts);
                    }

                }
            }
        });
    }

    getSourceCountries() {
        this.portService.getSourceCountryList().subscribe((response: any) => {
            if (response != null && response.succeeded && response.data != null) {
                this.masterSourceCountries = response.data;
                if (this.hasFinderSettingSet) {
                    let finderFromCountry = this.voyageFinderOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.FromCountry);
                    let trackerFromCountry = this.shipmentTrackerOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.FromCountry);
                    for (let element of this.masterSourceCountries) {
                        if (element.id == finderFromCountry.fieldValue) {
                            this.searchForm.controls.fromCountry.setValue(element as any);
                        }
                        if (element.id == trackerFromCountry.fieldValue) {
                            this.trackerForm.controls.fromCountry.setValue(element as any);
                        }
                    }

                }
            }
        });
    }

    getSourcePorts(toCountryId, isSetDefault: boolean, type: string) {
        this.portService.getSourcePortList(toCountryId).subscribe((response: any) => {
            if (response != null && response.succeeded && response.data != null) {
                if (type == OpenSearchScreen.Finder) {
                    this.masterSourcePorts = response.data;
                } else if (type == OpenSearchScreen.PortActivities) {
                    this.activitiesSourcePorts = response.data;
                } else if (type == OpenSearchScreen.Tracker) {
                    this.trackerSourcePorts = response.data;
                }
            }
            if (this.hasFinderSettingSet) {
                if (type == OpenSearchScreen.Finder) {
                    let finderFromPort = this.voyageFinderOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.FromPort);
                    let selectedFromPorts = this.masterSourcePorts.find(x => x.id == finderFromPort.fieldValue);
                    this.searchForm.controls.fromPort.setValue(selectedFromPorts);
                }
                // else if (type == OpenSearchScreen.PortActivities) {
                //     let finderFromPort = this.portActivitiesOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.FromPort);
                //     let selectedFromPorts = this.activitiesSourcePorts.find(x => x.id == finderFromPort.fieldValue);
                //     this.portActivitiesForm.controls.fromPort.setValue(selectedFromPorts);
                // } 
                else if (type == OpenSearchScreen.Tracker) {
                    let finderFromPort = this.shipmentTrackerOpenSearch.find(z => z.fieldName == OpenSearchFinderFields.FromPort);
                    let selectedFromPorts = this.trackerSourcePorts.find(x => x.id == finderFromPort.fieldValue);
                    this.trackerForm.controls.fromPort.setValue(selectedFromPorts);
                }

            }
        });
    }

    onDestinationCountrySelect(event, type: string) {
        this.resetDestinationPorts(type);
        let portId;
        if (type == OpenSearchScreen.Finder) {
            portId = this.searchForm.value.fromPort.id;
        } else if (type == OpenSearchScreen.PortActivities) {
            portId = this.portActivitiesForm.value.fromPort.id;
        } else if (type == OpenSearchScreen.Tracker) {
            portId = this.trackerForm.value.fromPort.id;
        }

        if (portId) {
            this.getDestinationPorts(event.value.id, [portId], false, type);
        }
    }

    onSourcePortChange(event, type: string) {
        this.resetDestinationCountries(type);
        let fromCountryId;
        if (type == OpenSearchScreen.Finder) {
            fromCountryId = this.searchForm.value.fromCountry.id;
        } else if (type == OpenSearchScreen.PortActivities) {
            fromCountryId = this.portActivitiesForm.value.fromCountry.id;
        } else if (type == OpenSearchScreen.Tracker) {
            fromCountryId = this.trackerForm.value.fromCountry.id;
        }

        let fromPortIds = event.value.id;
        if (fromPortIds) {
            this.getDestinationCountries(fromCountryId, [fromPortIds], false, type);
        }
    }

    onSourceCountrySelect(event, type: string) {
        this.resetSourcePorts(type);
        this.getSourcePorts(event.value.id, false, type);
    }


    resetSourcePorts(type: string) {
        if (type == OpenSearchScreen.Finder) {
            this.searchForm.controls.fromPort.reset();
            this.searchForm.controls.fromPort.setValue(null);
            this.masterSourcePorts = [];
        } else if (type == OpenSearchScreen.PortActivities) {
            this.portActivitiesForm.controls.fromPort.reset();
            this.portActivitiesForm.controls.fromPort.setValue(null);
            this.activitiesSourcePorts = [];
        } else if (type == OpenSearchScreen.Tracker) {
            this.trackerForm.controls.fromPort.reset();
            this.trackerForm.controls.fromPort.setValue(null);
            this.trackerSourcePorts = [];
        }
        this.resetDestinationCountries(type);
    }

    resetDestinationCountries(type: any) {
        if (type == OpenSearchScreen.Finder) {
            this.searchForm.controls.toCountry.reset();
            this.searchForm.controls.toCountry.setValue({});
            this.masterDestinationCountries = [];
        } else if (type == OpenSearchScreen.PortActivities) {
            this.portActivitiesForm.controls.toCountry.reset();
            this.portActivitiesForm.controls.toCountry.setValue({});
            this.actvitiesDestinationCountries = [];
        } else if (type == OpenSearchScreen.Tracker) {
            this.trackerForm.controls.toCountry.reset();
            this.trackerForm.controls.toCountry.setValue({});
            this.trackerDestinationCountries = [];
        }

        this.resetDestinationPorts(type);
    }

    resetDestinationPorts(type: any) {
        if (type == OpenSearchScreen.Finder) {
            this.searchForm.controls.toPort.reset();
            this.searchForm.controls.toPort.setValue([]);
            this.masterDestinationPorts = [];
        } else if (type == OpenSearchScreen.PortActivities) {
            this.portActivitiesForm.controls.toPort.reset();
            this.portActivitiesForm.controls.toPort.setValue([]);
            this.activitiesDestinationPorts = [];
        } else if (type == OpenSearchScreen.Tracker) {
            this.trackerForm.controls.toPort.reset();
            this.trackerForm.controls.toPort.setValue([]);
            this.trackerDestinationPorts = [];
        }


    }


}
